// Adds the free "Cadeau mystère" to the cart while a qualifying product is in it (max 1),
// and removes it again when no qualifying product is left. The price is made €0 by the
// automatic Buy X Get Y discount "Cadeau mystère offert – Projecteur de Noël".
// If the customer removes the gift themselves, it stays removed for that cart.
(() => {
  const cfg = window.mysteryGift;
  if (!cfg || !cfg.variantId || window.__mysteryGift) return;
  window.__mysteryGift = true;

  const giftId = Number(cfg.variantId);
  const triggers = (cfg.triggerProductIds || []).map(Number);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const storageKey = "mystery_gift_state";
  const originalFetch = window.fetch.bind(window);
  let busy = false;
  let queued = false;

  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey)) || {};
    } catch (e) {
      return {};
    }
  };
  const writeState = (state) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {}
  };
  const post = (path, body) =>
    originalFetch(`${root}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });

  async function check() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;

    try {
      let cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
      const gift = cart.items.find((item) => item.variant_id === giftId);
      const qualifies = cart.items.some((item) => triggers.includes(item.product_id));
      const state = readState();
      if (state.token !== cart.token) Object.assign(state, { token: cart.token, optOut: false, hadGift: false });

      // Gift was there and the product still is, so the customer removed the gift.
      if (state.hadGift && qualifies && !gift) state.optOut = true;
      if (!qualifies) state.optOut = false;

      let changed = false;
      if (qualifies && !gift && !state.optOut) {
        await post("cart/add.js", { items: [{ id: giftId, quantity: 1 }] });
        changed = true;
      } else if (gift && (!qualifies || gift.quantity > 1)) {
        await post("cart/change.js", { id: gift.key, quantity: qualifies ? 1 : 0 });
        changed = true;
      }

      if (changed) {
        cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
        if (typeof window.SLIDECART_SET_CART === "function") window.SLIDECART_SET_CART(cart);
      }
      state.hadGift = cart.items.some((item) => item.variant_id === giftId);
      writeState(state);
    } catch (e) {
      console.error(e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        setTimeout(check, 300);
      }
    }
  }

  const isCartChange = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));

  const wrappedFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input && input.url;
    const request = wrappedFetch.call(this, input, init);
    if (isCartChange(url)) request.then(() => setTimeout(check, 500)).catch(() => {});
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartChange(url)) this.addEventListener("loadend", () => setTimeout(check, 500));
    return originalOpen.apply(this, arguments);
  };

  check();
})();
